import { createSlice } from "@reduxjs/toolkit";
import {
  createBaseNavigation,
  getBaseNavigations,
  updateBaseNavigation,
} from "./baseNavigationThunk";

const initialState = {
  loading: false,
  baseNavigationlist: [],
  pagination: {},
  error: null,
};

const baseNavigationSlice = createSlice({
  name: "baseNavigation",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      // GET
      .addCase(getBaseNavigations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBaseNavigations.fulfilled, (state, action) => {
        state.loading = false;
        state.baseNavigationlist = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(getBaseNavigations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // CREATE
      .addCase(createBaseNavigation.pending, (state) => {
        state.loading = true;
      })
      .addCase(createBaseNavigation.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createBaseNavigation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // UPDATE
      .addCase(updateBaseNavigation.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateBaseNavigation.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateBaseNavigation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default baseNavigationSlice.reducer;
